/**
 * News slider
 */
(function($) {
  "use strict";

  $(window).ready(slickify);

  $(window).resize(slickify);

  // Constants
  var newsSlider = ".ListNews";

  /**
   * Init
   */
  function slickify() {
    $(newsSlider).not('.slick-initialized').slick({
      responsive: [
        {
          breakpoint: 99999,
          settings: "unslick"
        },
        {
          breakpoint: 1024,
          settings: {
            dots: true,
            arrows: false,
            speed: 500
          }
        }
      ]
    });
  }

  $(window).resize(function(){
    var $windowWidth = $(window).width();
    if ($windowWidth > 768) {
      slickify();
    }
  });

})(jQuery);
